import type { JSX } from "react";

import { componentManager, rwc } from "@frontend/bridge/ComponentManager";

import { TruncateMiddle } from "./TruncateMiddle";
import {
  type TruncateMiddleDataProps,
  truncateMiddleDataSchema,
} from "./TruncateMiddle.schema";
import { TRUNCATE_MIDDLE_TAG_NAME } from "./constants";

declare module "@frontend/bridge/types" {
  interface ComponentRegistryMap {
    [TRUNCATE_MIDDLE_TAG_NAME]: {
      props: TruncateMiddleDataProps;
      handle: undefined;
    };
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "rwc-truncate-middle": HTMLElement;
  }
}

function RWCTruncateMiddle(props: TruncateMiddleDataProps): JSX.Element {
  return <TruncateMiddle {...props} />;
}

componentManager.register(
  rwc(TRUNCATE_MIDDLE_TAG_NAME, {
    component: RWCTruncateMiddle,
    dataSchema: truncateMiddleDataSchema,
  }),
);
